'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _republishMessage = require('../../actions/PublishActions/republishMessage');

var _getChatHeadingConfig = require('../../chat-heading-config/selectors/getChatHeadingConfig');

var _navigateToStagedThread = require('../../navigation/actions/navigateToStagedThread');

var _navigateToThreadList = require('../../navigation/actions/navigateToThreadList');

var _getChatHeadingResponders = require('../../responders/selectors/getChatHeadingResponders');

var _getInitialMessageText = require('../../selectors/widgetDataSelectors/getInitialMessageText');

var _getIsMobile = require('../../selectors/getIsMobile');

var _getIsOpen = require('../../selectors/getIsOpen');

var _getShouldHideWelcomeMessage = require('../../selectors/getShouldHideWelcomeMessage');

var _getShowInitialMessage = require('../../selectors/getShowInitialMessage');

var _InitialMessageBubbleWrapper = require('conversations-internal-components/visitor-widget/components/InitialMessageBubbleWrapper');

var _InitialMessageBubbleWrapper2 = _interopRequireDefault(_InitialMessageBubbleWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    chatHeadingConfig: (0, _getChatHeadingConfig.getChatHeadingConfig)(state),
    chatHeadingResponders: (0, _getChatHeadingResponders.getChatHeadingResponders)(state),
    initialMessage: (0, _getInitialMessageText.getInitialMessageText)(state),
    mobile: (0, _getIsMobile.getIsMobile)(state),
    isOpen: (0, _getIsOpen.getIsOpen)(state),
    showInitialMessageBubble: (0, _getShowInitialMessage.getShowInitialMessage)(state),
    hideWelcomeMessage: (0, _getShouldHideWelcomeMessage.getShouldHideWelcomeMessage)(state)
  };
};

var mapDispatchToProps = {
  createNewThread: _navigateToStagedThread.navigateToStagedThread,
  republishMessage: _republishMessage.republishMessage,
  showThreadList: _navigateToThreadList.navigateToThreadList
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InitialMessageBubbleWrapper2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/initial-message-bubble/containers/InitialMessageBubbleContainer.js
// module id = 1185
// module chunks = 2 3